import React from 'react';

import {
    BrowserRouter, Route, Routes,
} from 'react-router-dom';

import ROUTES from '@CONSTANTS/ROUTES.constant';

import StepsValidator from '@VALIDATION/components/StepsValidator';
import { useAppSettingsStyles } from '@HOOKS/useAppSettingsStyles';
import { initializeAutoButtonColors } from '@HELPERS/colorUtils';

import BasicLayout from '@LAYOUTS/BasicLayout';
import BasicAdminLayout from '@LAYOUTS/BasicAdminLayout';
import GenerateDocumentLayout from '@LAYOUTS/GenerateDocument';
import EditDocumentLayout from '@LAYOUTS/EditDocument';

import MainPage from '@PAGES/common/main';
import LoginPage from '@PAGES/common/login';
import Page404 from '@PAGES/common/404';

import ProtectedRoute from '@COMPONENTS/SHARED/ProtectedRoute/ProtectedRoute.component';

// MANAGER
import ChooseDocumentPage from '@PAGES/manager/choose-documement';
import BrandPage from '@PAGES/manager/brand';
import LocationPage from '@PAGES/manager/location';
import PropertyPage from '@PAGES/manager/property';
import OptionsPage from '@PAGES/manager/options';
import SelectContentPage from '@PAGES/manager/select-content';
import DownloadDocumentPage from '@PAGES/manager/download-document';

// ADMIN
import VendorsPage from '@PAGES/admin/vendors';
import LogsPage from '@PAGES/admin/logs';
import UsersPermissionsPage from '@PAGES/admin/users-permissions';
import AppSettingsPage from '@PAGES/admin/app-settings';
import SystemSettingsPage from '@PAGES/admin/system-settings';
import DocumentsListPage from '@PAGES/admin/documents-list';
import DocumentPage from '@PAGES/admin/document';
import EditChapterPage from '@PAGES/admin/edit-chapter';
import EditSectionPage from '@PAGES/admin/edit-section';

import AppWrapper from './AppWrapper';

function AppRouter() {
    useAppSettingsStyles();
    
    // Initialize automatic button colors on app startup
    React.useEffect(() => {
        initializeAutoButtonColors();
    }, []);
    
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<ProtectedRoute />}>
                    <Route element={<AppWrapper />}>
                        <Route path={ROUTES.login.path} element={<LoginPage />} />

                        {/* COMMON */}
                        <Route element={<BasicLayout />}>
                            <Route path={ROUTES.main.path} element={<MainPage />} />
                        </Route>

                        {/* MANAGER */}
                        <Route element={<StepsValidator />}>
                            <Route element={<GenerateDocumentLayout />}>
                                <Route
                                    path={ROUTES.chooseDocument.path}
                                    element={<ChooseDocumentPage />}
                                />
                                <Route path={ROUTES.brand.path} element={<BrandPage />} />
                                <Route path={ROUTES.location.path} element={<LocationPage />} />
                                <Route path={ROUTES.type.path} element={<PropertyPage />} />
                                <Route path={ROUTES.options.path} element={<OptionsPage />} />
                                <Route
                                    path={ROUTES.selectContent.path}
                                    element={<SelectContentPage />}
                                />
                                <Route
                                    path={ROUTES.downloadDocument.path}
                                    element={<DownloadDocumentPage />}
                                />
                            </Route>
                        </Route>

                        {/* ADMIN */}
                        <Route element={<BasicAdminLayout />}>
                            <Route
                                path={ROUTES.admin.manageVendors.path}
                                element={<VendorsPage />}
                            />
                            <Route
                                path={ROUTES.admin.logs.path}
                                element={<LogsPage />}
                            />

                            <Route
                                path={ROUTES.admin.manageUsersPermissions.path}
                                element={<UsersPermissionsPage />}
                            />

                            <Route
                                path={ROUTES.admin.appSettings.path}
                                element={<AppSettingsPage />}
                            />

                            <Route
                                path={ROUTES.admin.systemSettings.path}
                                element={<SystemSettingsPage />}
                            />
                        </Route>

                        <Route path={ROUTES.admin.path} element={<EditDocumentLayout />}>
                            <Route
                                path={ROUTES.admin.documents.path}
                                element={<DocumentsListPage />}
                            />
                            <Route
                                path={ROUTES.admin.documents.id.path}
                                element={<DocumentPage />}
                            />
                            <Route
                                path={ROUTES.admin.chapters.id.path}
                                element={<EditChapterPage />}
                            />
                            <Route
                                path={ROUTES.admin.sections.id.path}
                                element={<EditSectionPage />}
                            />
                        </Route>

                        {/* 404 */}
                        <Route element={<BasicLayout />}>
                            <Route path="*" element={<Page404 />} />
                        </Route>
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default AppRouter;
